export function getNewUtcDate(match: string[]) {
    return new Date(
        Date.UTC(parseInt(match[1], 10), parseInt(match[2], 10) - 1, parseInt(match[3], 10))
    )
}
